/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */

import { Component, ElementRef, HostListener, OnDestroy, OnInit, computed, effect, inject, input, model, output, signal, viewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { AIAgentService } from '../../services/ai-agent.service';

/**
 * Chat Flyout Component
 * 
 * Provides a resizable, collapsible flyout panel for chat interface.
 * Features:
 * - Configurable width/height as percentage of screen
 * - Vertical resize with drag handle
 * - Split view with optional right panel for chat history
 * - Left or right screen positioning
 * - Persistent footer option
 * 
 * @example
 * <app-chat-flyout 
 *   [(isOpen)]="showChat"
 *   [headerText]="'Chat with EVA'"
 *   [flyoutWidthPercent]="40"
 *   (onRightPanelToggle)="handlePanelToggle($event)">
 *   <div leftPanel>Main chat content</div>
 *   <div rightPanel>Chat history</div>
 * </app-chat-flyout>
 */
@Component({
    selector: 'app-chat-flyout',
    templateUrl: './chat-flyout.component.html',
    styleUrl: './chat-flyout.component.scss',
    standalone: false,
})
export class ChatFlyoutComponent implements OnInit, OnDestroy {
    readonly translate = inject(TranslateService);
    readonly aiAgentService = inject(AIAgentService);

    /** Controls flyout visibility (two-way binding) */
    readonly isOpen = model(false);

    /** Header text to display at top of flyout */
    readonly headerText = input('');

    /** Flyout width as percentage of screen width (20-100) */
    readonly flyoutWidthPercent = input<number>(29);

    /** Optional flyout height as percentage of screen height */
    readonly flyoutHeightPercent = input<number | undefined>(undefined);

    /** Position of flyout: 'left' or 'right' side of screen */
    readonly flyoutPosition = input<'left' | 'right'>('right');

    /** Whether footer should stick to bottom */
    readonly pinFooterToBottom = input(true);

    /** Whether the close button is visible in the header */
    readonly showCloseButton = input(false);

    /** Direction in which the flyout expands when resized: 'horizontal' (default) or 'vertical' */
    readonly expandDirection = input<'horizontal' | 'vertical'>('horizontal');

    /** Direction from which the flyout opens: 'right-to-left' (default, for right-positioned flyout), 'left-to-right', or 'bottom-to-top' */
    readonly openDirection = input<'left-to-right' | 'right-to-left' | 'bottom-to-top'>('right-to-left');

    /** Emits when right panel is toggled */
    readonly onRightPanelToggle = output<boolean>();

    /** Emits flyout width percentage changes while resizing horizontally. */
    readonly onWidthChange = output<number>();

    private readonly destroy$ = new Subject<void>();

    /** Whether the flyout is collapsed to show only the resize tab */
    public isCollapsed = false;

    /** Reference to flyout container element */
    readonly flyoutElement = viewChild<ElementRef>('flyout');

    /** Reference to resize handle element */
    readonly resizeHandle = viewChild<ElementRef>('resizeHandle');

    /** Initial height before resize drag */
    private initialHeight = 0;

    /** Indicates if user is currently dragging resize handle */
    private isDragging = false;

    /** Screen height in pixels */
    private screenHeight = 0;

    /** Minimum flyout height as percentage */
    private minHeight = 30;

    /** Maximum flyout height as percentage */
    private maxHeight = 100;

    /** Current flyout height as percentage */
    public currentHeight = 100;

    /** Current flyout width as percentage */
    public currentWidth = 29;

    /** Controls visibility of right panel (chat history) */
    public showRightPanel = false;

    /** Left panel width as percentage of flyout width */
    public leftPanelWidth = 100;

    /** Right panel width as percentage of flyout width */
    public rightPanelWidth = 0;

    /** Height threshold (%) for enabling split view */
    public splitThreshold = 50;

    /** Keep resize handle hidden until flyout has been collapsed/closed once. */
    public shouldRenderResizeHandle = signal<boolean>(false);

    /** Tracks if right panel was manually toggled by user */
    private isRightPanelManuallyToggled = false;

    private readonly mobileBreakpoint = 720;

    readonly resolvedFlyoutWidth = computed(() => {
        const minWidth = 1;
        const maxWidth = 100;
        const parsedWidth = Number(this.flyoutWidthPercent());

        if (Number.isNaN(parsedWidth)) {
            return 29;
        }

        return Math.min(maxWidth, Math.max(minWidth, parsedWidth));
    });

    /**
     * Get resolved flyout height with bounds checking
     * @returns Validated height percentage or default 100%
     */
    readonly resolvedFlyoutHeight = computed(() => {
        const defaultHeight = 100;
        const heightPercent = this.flyoutHeightPercent();
        const parsedHeight = heightPercent !== undefined ? Number(heightPercent) : NaN;

        if (Number.isNaN(parsedHeight)) {
            return defaultHeight;
        }

        return Math.min(this.maxHeight, Math.max(this.minHeight, parsedHeight));
    });

    /**
     * Check if flyout is positioned on the left side
     * @returns True if left-positioned
     */
    readonly isLeftPosition = computed(() => {
        return this.flyoutPosition() === 'left';
    });

    /**
     * Check if footer should be pinned to bottom
     * @returns True if footer should pin
     */
    readonly shouldPinFooter = computed(() => {
        return this.pinFooterToBottom();
    });

    readonly isHorizontalExpand = computed(() => this.expandDirection() === 'horizontal');

    constructor() {
        // React to flyoutHeightPercent changes
        effect(() => {
            const heightPercent = this.flyoutHeightPercent();
            if (heightPercent !== undefined) {
                this.currentHeight = this.resolvedFlyoutHeight();
                this.updatePanelSizes();
            }
        });

        // React to flyoutWidthPercent changes
        effect(() => {
            this.currentWidth = this.resolvedFlyoutWidth();
        });
    }

    /**
     * Initialize component
     * Sets up initial dimensions and panel sizes
     */
    ngOnInit(): void {
        this.currentHeight = this.resolvedFlyoutHeight();
        this.currentWidth = this.resolvedFlyoutWidth();
        this.updateScreenHeight();
        this.updatePanelSizes();
        // this.closeFlyout();
        this.aiAgentService.getEvaState$()
            .pipe(takeUntil(this.destroy$))
            .subscribe(state => {
                if (state.show) {
                    if (typeof state.collapsed === 'boolean' && state.collapsed) {
                        this.shouldRenderResizeHandle.set(true);
                        this.isCollapsed = true;
                        this.isOpen.set(true);
                    } else if (typeof state.collapsed === 'boolean' && !state.collapsed) {
                        this.shouldRenderResizeHandle.set(true);
                        this.isCollapsed = false;
                        this.isOpen.set(true);
                    }
                } else if (typeof state.show === 'boolean' && !state.show) {
                    this.isCollapsed = false;
                    this.isOpen.set(false);
                    this.shouldRenderResizeHandle.set(false);
                }
            });
    }

    /**
     * Handle window resize events
     * @param event - Resize event
     */
    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        this.updateScreenHeight();
        this.updatePanelSizes();
    }

    /**
     * Update screen height tracking
     * @private
     */
    private updateScreenHeight(): void {
        this.screenHeight = window.innerHeight;
    }

    /**
     * Updates the panel sizes based on the current flyout height
     * - If flyout height > splitThreshold, show both panels (60/40 split)
     * - Otherwise, show only left panel (100% width)
     */
    private updatePanelSizes(): void {
        const shouldShowRightPanel = this.currentHeight > this.splitThreshold;
        const isMobileWidth = window.innerWidth < this.mobileBreakpoint;

        // Only auto-close the right panel on resize; never auto-open it.
        if (!shouldShowRightPanel && this.showRightPanel && !this.isRightPanelManuallyToggled) {
            this.showRightPanel = false;
            this.leftPanelWidth = 100;
            this.rightPanelWidth = 0;
        } else if (this.showRightPanel) {
            // Re-apply correct split on resize (mobile ↔ desktop switch)
            if (isMobileWidth) {
                this.leftPanelWidth = 0;
                this.rightPanelWidth = 100;
            } else {
                this.leftPanelWidth = 70;
                this.rightPanelWidth = 30;
            }
        }
    }

    /**
     * Close the right panel and restore the left panel to full width
     */
    closeRightPanel(): void {
        if (this.showRightPanel) {
            this.toggleRightPanel();
        }
    }

    /**
     * Toggle right panel visibility manually
     * Adjusts panel widths and flyout height as needed
     */
    toggleRightPanel(): void {
        this.isRightPanelManuallyToggled = true;
        this.showRightPanel = !this.showRightPanel;

        if (this.showRightPanel) {
            const isMobileWidth = window.innerWidth < this.mobileBreakpoint;
            const isShortFlyout = this.currentHeight < this.splitThreshold;

            if (isMobileWidth || isShortFlyout) {
                this.leftPanelWidth = 0;
                this.rightPanelWidth = 100;
            } else {
                this.leftPanelWidth = 70;
                this.rightPanelWidth = 30;
            }

            if (isShortFlyout) {
                this.currentHeight = this.splitThreshold + 5;
            }
        } else {
            this.leftPanelWidth = 100;
            this.rightPanelWidth = 0;
        }

        // Reset the manual toggle flag after a delay
        setTimeout(() => {
            this.isRightPanelManuallyToggled = false;
            this.onRightPanelToggle.emit(this.showRightPanel);
        }, 500);
    }

    /**
     * Toggle flyout open/closed state
     */
    toggleFlyout(): void {
        this.isOpen.set(!this.isOpen());

        if (this.isOpen()) {
            this.shouldRenderResizeHandle.set(true);
            this.isCollapsed = false;
            this.resetFlyoutState();
            this.aiAgentService.setEvaState({ show: true, collapsed: false });
        } else {
            this.shouldRenderResizeHandle.set(true);
            // Always collapse to keep the resize tab visible at the edge
            this.isCollapsed = true;
            this.aiAgentService.setEvaState({ show: true, collapsed: true });
        }
    }

    /**
     * Open the flyout panel
     */
    openFlyout(): void {
        if (this.isOpen()) {
            return;
        }

        this.isOpen.set(true);
        this.shouldRenderResizeHandle.set(true);
        this.isCollapsed = false;
        this.resetFlyoutState();
    }

    /**
     * Start resizing flyout height
     * Attaches mouse move listeners for drag operation
     * 
     * @param event - Mouse down event on resize handle
     */
    startResize(event: MouseEvent): void {
        event.preventDefault();

        // If collapsed, open the flyout first then begin drag
        if (this.isCollapsed) {
            this.isCollapsed = false;
            this.isOpen.set(true);
            this.aiAgentService.setEvaState({ show: true, collapsed: false });
        }

        this.isDragging = true;
        const flyoutEl = this.flyoutElement();
        if (flyoutEl) {
            this.initialHeight = flyoutEl.nativeElement.offsetHeight;
        }

        // Add mousemove and mouseup event listeners
        document.addEventListener('mousemove', this.resizeMouseMove);
        document.addEventListener('mouseup', this.resizeMouseUp);
    }

    /**
     * Handle mouse move during resize operation
     * @param event - Mouse move event
     */
    @HostListener('document:mousemove', ['$event'])
    private resizeMouseMove = (event: MouseEvent) => {
        if (this.isDragging) {
            if (this.isHorizontalExpand()) {
                const screenWidth = window.innerWidth;
                const minWidth = 20;
                const maxWidth = 100;
                const newWidth = this.isLeftPosition()
                    ? (event.clientX / screenWidth) * 100
                    : ((screenWidth - event.clientX) / screenWidth) * 100;
                if (newWidth >= minWidth && newWidth <= maxWidth) {
                    this.currentWidth = newWidth;
                    this.onWidthChange.emit(newWidth);
                }
            } else {
                const newHeight = 100 - ((event.clientY / this.screenHeight) * 100);
                if (newHeight >= this.minHeight && newHeight <= this.maxHeight) {
                    this.currentHeight = newHeight;
                    this.updatePanelSizes();
                }
            }
        }
    }

    /**
     * Handle mouse up to end resize operation
     * Cleans up event listeners
     */
    private resizeMouseUp = () => {
        this.isDragging = false;

        // Remove event listeners
        document.removeEventListener('mousemove', this.resizeMouseMove);
        document.removeEventListener('mouseup', this.resizeMouseUp);
    }

    /**
     * Close the flyout panel
     * Resets panel states
     */
    closeFlyout(): void {
        this.shouldRenderResizeHandle.set(true);
        this.isOpen.set(false);
        this.isCollapsed = false;
        // Reset panel states
        this.showRightPanel = false;
        this.leftPanelWidth = 100;
        this.rightPanelWidth = 0;
        this.isRightPanelManuallyToggled = false;
        this.aiAgentService.setEvaState({ show: false, collapsed: false });
    }

    /**
     * Reset flyout to initial state
     * @private
     */
    private resetFlyoutState(): void {
        this.currentHeight = this.resolvedFlyoutHeight();
        this.showRightPanel = false;
        this.leftPanelWidth = 100;
        this.rightPanelWidth = 0;
        this.isRightPanelManuallyToggled = false;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}